export const CreatorProfileSvg = ({
  className = '',
  color = '#00FF99',
  shadowOpacity = 0.5,
  ...props
}) => {
  // Parse hex color to RGB components for filter matrices
  const getRgbFromHex = (hex) => {
    // Remove # if present
    const cleanHex = hex.charAt(0) === '#' ? hex.substring(1) : hex;

    // Parse hex values
    const r = parseInt(cleanHex.substring(0, 2), 16) / 255;
    const g = parseInt(cleanHex.substring(2, 4), 16) / 255;
    const b = parseInt(cleanHex.substring(4, 6), 16) / 255;

    return { r, g, b };
  };

  const rgb = getRgbFromHex(color);

  // Create color matrix values string (used in feColorMatrix)
  const getColorMatrix = (opacity = shadowOpacity) => {
    return `0 0 0 0 ${rgb.r} 0 0 0 0 ${rgb.g} 0 0 0 0 ${rgb.b} 0 0 0 ${opacity} 0`;
  };

  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 1225 75"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g clipPath="url(#clip0_4637_181)">
        <g clipPath="url(#clip1_4637_181)">
          <g opacity="0.15" clipPath="url(#clip2_4637_181)">
            <path
              d="M83.9392 32.1522C93.6512 41.5297 94.1568 56.0855 100.321 65.0556C106.539 74.1055 114.719 70.4952 119.661 82.8613C125.923 98.5321 113.186 111.813 103.877 118.532C94.381 125.391 76.9463 123.831 65.0589 121.42C52.9467 118.961 35.0836 112.81 30.5086 100.917C23.9859 83.9629 35.2386 81.6493 38.2324 68.4808C41.2261 55.3122 27.7288 45.5246 41.1099 31.1519C49.1525 22.5104 70.3121 18.9979 83.9339 32.1499L83.9392 32.1522Z"
              stroke={color}
              strokeWidth="0.35"
              strokeMiterlimit="10"
            />
            <path
              d="M99.7623 28.7016C107.555 42.7589 103.07 59.5087 106.962 71.8723C110.888 84.3451 121.461 83.0766 122.783 98.8807C124.457 118.903 105.336 129.588 92.4028 134.004C79.2056 138.506 59.9072 130.662 47.2126 123.778C34.2785 116.765 16.0854 103.535 15.0165 88.4072C13.4888 66.831 27.1041 68.1172 35.0931 54.166C43.0821 40.2148 31.1245 24.3744 51.3617 12.6703C63.5255 5.63574 88.8344 8.99734 99.7629 28.7144L99.7623 28.7016Z"
              stroke={color}
              strokeWidth="0.42"
              strokeMiterlimit="10"
            />
            <path
              d="M118.979 30.2865C122.955 49.0051 112.02 66.5104 112.152 81.9422C112.28 97.5112 124.758 99.7509 120.762 118.199C115.701 141.577 90.2211 147.084 73.9584 147.606C57.3706 148.139 38.1269 132.489 26.0731 120.232C13.7923 107.744 -2.31572 86.3505 1.73402 68.7505C7.50409 43.6532 22.5579 49.856 36.5064 36.7555C50.4571 23.6496 42.3595 1.45499 69.4667 -4.83069C85.7581 -8.60667 113.405 4.03323 118.984 30.2888L118.979 30.2865Z"
              stroke={color}
              strokeWidth="0.5"
              strokeMiterlimit="10"
            />
            <path
              d="M140.3 38.7761C138.316 61.4707 119.775 77.5993 114.55 95.2113C109.282 112.981 122.703 119.872 111.737 139.491C97.838 164.344 66.918 161.749 48.219 156.682C29.1501 151.511 12.6928 126.996 3.23129 108.841C-6.40364 90.3464 -17.2981 60.3796 -6.56058 41.7502C8.74252 15.1847 23.7143 27.488 44.1564 17.4272C64.5984 7.36649 63.1018 -20.7287 96.1451 -18.4456C116.007 -17.0715 143.081 6.94345 140.292 38.7791L140.3 38.7761Z"
              stroke={color}
              strokeWidth="0.59"
              strokeMiterlimit="10"
            />
            <path
              d="M161.616 55.867C151.458 81.0161 124.742 92.9216 112.672 111.155C100.493 129.555 113.37 142.076 94.0584 160.588C69.5856 184.047 35.2924 170.327 15.7755 158.045C-4.13433 145.524 -14.3356 111.874 -18.7858 87.9153C-23.3171 63.5057 -25.2887 25.5943 -6.59049 8.11804C20.0756 -16.7987 32.8358 2.42357 59.6084 -1.91799C86.3786 -6.25425 94.4528 -38.759 131.274 -24.6594C153.405 -16.1826 175.866 20.5871 161.619 55.8617L161.616 55.867Z"
              stroke={color}
              strokeWidth="0.71"
              strokeMiterlimit="10"
            />
            <path
              d="M179.935 82.7454C159.622 107.84 125.06 112.097 104.973 128.656C84.7084 145.364 95.0105 164.104 66.5833 178.458C30.5629 196.65 -3.70671 169.083 -21.65 148.309C-39.9543 127.12 -39.8645 85.2578 -36.5935 56.4259C-33.2585 27.0554 -22.3146 -16.7964 5.05605 -30.1799C44.0809 -49.2647 51.9256 -22.9381 83.9085 -18.5603C115.891 -14.1826 136.394 -48.3771 173.404 -19.5003C195.65 -2.14428 208.42 47.5418 179.925 82.7408L179.935 82.7454Z"
              stroke={color}
              strokeWidth="0.84"
              strokeMiterlimit="10"
            />
            <path
              d="M191.438 119.729C159.579 141.233 118.758 134.043 90.1316 145.9C61.2448 157.863 66.4578 182.789 29.1011 189.238C-18.2324 197.408 -47.6467 154.095 -60.8481 124.196C-74.3118 93.6992 -59.6379 46.0673 -45.8799 14.3816C-32.1219 -17.3042 -4.14694 -64.0129 31.6679 -69.721C82.7378 -77.8615 82.4979 -45.1583 117.383 -29.0356C152.269 -12.9128 187.509 -44.7109 219.591 1.05093C238.877 28.5567 236.121 89.5699 191.438 119.729Z"
              stroke={color}
              strokeMiterlimit="10"
            />
          </g>
          <g opacity="0.41" filter="url(#filter0_d_4637_181)">
            <path
              d="M1095.53 9.21112C1107.26 8.03334 1120.36 12.7342 1130.49 13.0088C1140.7 13.2843 1140.37 8.39572 1153.08 10.3675C1169.19 12.8667 1176.51 23.0704 1179.21 29.5178C1181.97 36.0989 1174.48 43.3838 1168.17 47.8976C1161.74 52.4964 1150.01 58.4195 1137.85 56.4445C1120.51 53.6292 1122.4 47.801 1111.76 42.0017C1101.12 36.2023 1087.69 38.9371 1079.63 28.0722C1074.78 21.5427 1079.08 10.8673 1095.53 9.21112Z"
              fill={color}
            />
          </g>
          <g filter="url(#filter1_d_4637_181)">
            <path
              d="M1211.44 52.5956C1188.1 51.6389 1171.19 40.4039 1153.01 37.3962C1134.66 34.364 1127.84 42.7095 1107.5 36.1852C1081.71 27.9145 1083.79 8.83219 1088.63 -2.74237C1093.56 -14.5583 1118.4 -24.9865 1136.86 -31.0291C1155.66 -37.1863 1186.21 -44.2496 1205.55 -37.8561C1233.12 -28.7421 1220.78 -19.3687 1231.5 -6.89509C1242.23 5.5785 1271.05 4.32929 1269.34 24.7164C1268.31 36.9691 1244.18 53.9298 1211.44 52.5956Z"
              fill={color}
            />
          </g>
          <path
            opacity="0.15"
            d="M758.47 163.108C826.674 160.312 876.097 127.481 929.227 118.691C982.84 109.83 1002.77 134.218 1062.21 115.153C1137.58 90.9835 1131.52 35.2202 1117.37 1.39645C1102.96 -33.1325 1030.36 -63.6065 976.419 -81.2642C921.488 -99.2573 832.21 -119.898 775.695 -101.214C695.124 -74.5811 731.195 -47.1897 699.852 -10.7388C668.51 25.7121 584.302 22.0616 589.296 81.6378C592.282 117.443 662.802 167.007 758.47 163.108Z"
            fill={color}
          />
          <path
            d="M665.004 35.125C691.797 33.6482 711.041 20.4698 731.876 16.7208C752.9 12.941 760.868 22.4164 784.126 14.5932C813.617 4.67578 810.927 -17.209 805.178 -30.4254C799.321 -43.9176 770.616 -55.4935 749.318 -62.1353C727.626 -68.9034 692.421 -76.5219 670.31 -68.8651C638.788 -57.9503 653.118 -47.3836 641.001 -32.8826C628.883 -18.3815 595.764 -19.3499 598.057 4.03945C599.429 18.0966 627.422 37.1875 665.004 35.125Z"
            fill={color}
          />
          <g style={{ mixBlendMode: 'plus-lighter' }} opacity="0.46">
            <path
              d="M1084.89 57.603C1082.31 58.0235 1079.42 56.5728 1077.19 56.5236C1074.94 56.4745 1075.03 58.0336 1072.23 57.4525C1068.67 56.716 1067.04 53.487 1066.42 51.4393C1065.8 49.3492 1067.42 46.9956 1068.8 45.5309C1070.2 44.0386 1072.76 42.1035 1075.45 42.6877C1079.27 43.5204 1078.87 45.3879 1081.23 47.1985C1083.58 49.0091 1086.53 48.0852 1088.33 51.5225C1089.42 53.5881 1088.5 57.0119 1084.89 57.603Z"
              fill={color}
            />
          </g>
          <g
            style={{ mixBlendMode: 'plus-lighter' }}
            opacity="0.5"
            filter="url(#filter2_d_4637_181)"
          >
            <circle cx="1087" cy="39" r="8" fill={color} />
          </g>
          <g filter="url(#filter3_d_4637_181)">
            <circle cx="1072" cy="39" r="3" fill={color} />
          </g>
          <g
            style={{ mixBlendMode: 'plus-lighter' }}
            opacity="0.5"
            filter="url(#filter4_d_4637_181)"
          >
            <circle cx="698.5" cy="76.5" r="33.5" fill={color} />
          </g>
          <g
            style={{ mixBlendMode: 'plus-lighter' }}
            opacity="0.5"
            filter="url(#filter5_d_4637_181)"
          >
            <circle cx="735" cy="52" r="7" fill={color} />
          </g>
          <g
            style={{ mixBlendMode: 'plus-lighter' }}
            opacity="0.5"
            filter="url(#filter6_d_4637_181)"
          >
            <circle cx="734.5" cy="40.5" r="2.5" fill={color} />
          </g>
          <circle cx="1129.5" cy="55.5" r="2.5" fill={color} />
          <g opacity="0.2" clipPath="url(#clip3_4637_181)">
            <path
              d="M1098.23 46.4211C1092.33 62.1618 1075.96 69.9567 1068.78 81.4443C1061.52 93.0325 1069.7 100.583 1058.03 112.358C1043.24 127.28 1021.76 119.32 1009.47 112.02C996.928 104.578 990.065 83.8941 986.924 69.1233C983.726 54.0723 981.893 30.623 993.205 19.5018C1009.33 3.64614 1017.55 15.3493 1034.08 12.2385C1050.6 9.12772 1055.08 -11.139 1078.13 -2.9849C1091.99 1.91475 1106.49 24.3368 1098.23 46.4139V46.4211Z"
              stroke={color}
              strokeWidth="0.35"
              strokeMiterlimit="10"
            />
            <path
              d="M1110.01 62.7796C1097.82 78.6496 1076.47 81.8322 1064.28 92.4074C1051.99 103.076 1058.68 114.521 1041.29 123.867C1019.25 135.707 997.568 119.169 986.112 106.589C974.426 93.7508 973.815 67.8229 975.382 49.9126C976.977 31.6646 983.065 4.32861 999.81 -4.39306C1023.69 -16.8362 1028.97 -0.650067 1048.87 1.55549C1068.76 3.76106 1080.92 -17.7486 1104.32 -0.441723C1118.39 9.96106 1127.1 40.53 1110 62.7868L1110.01 62.7796Z"
              stroke={color}
              strokeWidth="0.42"
              strokeMiterlimit="10"
            />
            <path
              d="M1117.73 85.5106C1098.33 99.3331 1072.91 95.5254 1055.36 103.328C1037.64 111.194 1041.27 126.554 1018.22 131.138C989.015 136.95 970.092 110.584 961.432 92.271C952.6 73.5919 960.929 43.8564 968.95 24.0135C977.121 3.79703 993.565 -25.2057 1015.67 -29.308C1047.19 -35.1631 1047.57 -14.8964 1069.45 -5.46346C1091.33 3.96945 1112.67 -16.2829 1133.28 11.556C1145.67 28.2881 1144.95 66.1275 1117.73 85.5178V85.5106Z"
              stroke={color}
              strokeWidth="0.5"
              strokeMiterlimit="10"
            />
            <path
              d="M1118.61 114.068C1091.71 123.055 1064.1 109.88 1041.39 112.646C1018.49 115.44 1017.27 134.184 989.432 131.389C954.159 127.84 941.791 91.2437 938.305 67.3776C934.755 43.0374 954.59 12.0877 970.631 -7.71927C986.974 -27.8926 1015.79 -55.1927 1042.39 -52.1682C1080.32 -47.8648 1073.69 -24.6669 1095.32 -6.31115C1116.94 12.0446 1148.28 -3.59551 1162.06 35.2712C1170.34 58.6344 1156.34 101.46 1118.6 114.061L1118.61 114.068Z"
              stroke={color}
              strokeWidth="0.59"
              strokeMiterlimit="10"
            />
            <path
              d="M1109.66 146.886C1075.9 147.755 1049.06 123.149 1022.25 118.407C995.203 113.623 987.291 134.536 956.574 121.662C917.65 105.346 916.313 59.3815 920.661 31.0037C925.088 2.05844 958.457 -26.2762 983.611 -43.2382C1009.24 -60.5163 1051.56 -81.5661 1080.78 -68.8788C1122.46 -50.7816 1106.84 -26.6785 1125.07 1.74233C1143.3 30.1632 1184.42 23.2663 1186.57 72.3059C1187.87 101.783 1157.02 145.664 1109.67 146.886H1109.66Z"
              stroke={color}
              strokeWidth="0.71"
              strokeMiterlimit="10"
            />
            <path
              d="M1088.05 181.133C1049.32 170.378 1027.32 133.02 998.452 118.292C969.323 103.435 953.031 124.492 922.544 99.1463C883.908 67.0328 898.396 14.2286 913.223 -16.5631C928.344 -47.9726 976.194 -68.6273 1010.74 -79.1881C1045.94 -89.9429 1101.44 -99.189 1130.29 -74.5686C1171.44 -39.4664 1145.26 -17.4539 1156.12 21.2404C1166.98 59.9347 1216.2 66.3934 1201.57 122.976C1192.78 156.987 1142.38 196.205 1088.05 181.119V181.133Z"
              stroke={color}
              strokeWidth="0.84"
              strokeMiterlimit="10"
            />
            <path
              d="M1051.52 212.607C1011.17 186.887 999.135 136.705 971.4 109.894C943.415 82.838 917.535 101.151 891.648 61.6876C858.847 11.6853 893.725 -43.3819 921.322 -73.2827C949.473 -103.78 1011.14 -110.641 1054.15 -110.641C1097.16 -110.641 1164.37 -101.854 1188.64 -63.7851C1223.26 -9.50101 1185.8 6.44083 1184.68 54.2735C1183.57 102.106 1237.36 126.583 1201.01 185.91C1179.16 221.573 1108.12 248.679 1051.52 212.607Z"
              stroke={color}
              strokeMiterlimit="10"
            />
          </g>
          <g
            style={{ mixBlendMode: 'plus-lighter' }}
            opacity="0.75"
            filter="url(#filter7_d_4637_181)"
          >
            <path
              d="M4.03563 -9.40465C18.264 -13.8069 38.178 -9.34599 48.5148 0.559017C54.3881 12.2279 46.2374 11.728 43.8287 13.7026C39.7577 17.0399 46.0509 22.7277 41.4683 26.4645C32.0031 34.1828 7.32592 26.4059 -3.01084 16.5009C-13.3476 6.59588 -10.1928 -5.00242 4.03563 -9.40465Z"
              fill={color}
            />
          </g>
          <g
            style={{ mixBlendMode: 'plus-lighter' }}
            opacity="0.5"
            filter="url(#filter8_d_4637_181)"
          >
            <ellipse
              cx="6.40391"
              cy="7.97297"
              rx="6.40391"
              ry="7.97297"
              transform="matrix(-0.633867 -0.667537 0.8874 -0.301746 50.4394 23.656)"
              fill={color}
            />
          </g>
          <g opacity="0.4" filter="url(#filter9_d_4637_181)">
            <ellipse
              cx="3.17783"
              cy="3.95645"
              rx="3.17783"
              ry="3.95645"
              transform="matrix(-0.633867 -0.667537 0.8874 -0.301746 62.2805 26.2679)"
              fill={color}
            />
          </g>
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_4637_181"
          x="1062.85"
          y="-5.8779"
          width="131.85"
          height="77.6131"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="7.45" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values={getColorMatrix(0.5)} />
          <feBlend
            mode="plus-lighter"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4637_181"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4637_181"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_4637_181"
          x="1070.73"
          y="-55.277"
          width="213.574"
          height="122.847"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="7.45" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values={getColorMatrix(0.75)} />
          <feBlend
            mode="plus-lighter"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4637_181"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4637_181"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_4637_181"
          x="1064.1"
          y="16.1"
          width="45.8"
          height="45.8"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="7.45" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values={getColorMatrix(0.5)} />
          <feBlend
            mode="plus-lighter"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4637_181"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4637_181"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_4637_181"
          x="1054.1"
          y="21.1"
          width="35.8"
          height="35.8"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="7.45" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values={getColorMatrix(0.5)} />
          <feBlend
            mode="plus-lighter"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4637_181"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4637_181"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_d_4637_181"
          x="650.1"
          y="28.1"
          width="96.8"
          height="96.8"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="7.45" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values={getColorMatrix(0.5)} />
          <feBlend
            mode="plus-lighter"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4637_181"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4637_181"
            result="shape"
          />
        </filter>
        <filter
          id="filter5_d_4637_181"
          x="713.1"
          y="30.1"
          width="43.8"
          height="43.8"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="7.45" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values={getColorMatrix(0.5)} />
          <feBlend
            mode="plus-lighter"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4637_181"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4637_181"
            result="shape"
          />
        </filter>
        <filter
          id="filter6_d_4637_181"
          x="717.1"
          y="23.1"
          width="34.8"
          height="34.8"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="7.45" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values={getColorMatrix(0.5)} />
          <feBlend
            mode="plus-lighter"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4637_181"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4637_181"
            result="shape"
          />
        </filter>
        <filter
          id="filter7_d_4637_181"
          x="-23.9941"
          y="-26.0011"
          width="89.4939"
          height="70.4984"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="7.45" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values={getColorMatrix(0.5)} />
          <feBlend
            mode="plus-lighter"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4637_181"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4637_181"
            result="shape"
          />
        </filter>
        <filter
          id="filter8_d_4637_181"
          x="30.3971"
          y="-2.83091"
          width="46.1166"
          height="39.6125"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="7.45" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values={getColorMatrix(0.5)} />
          <feBlend
            mode="plus-lighter"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4637_181"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4637_181"
            result="shape"
          />
        </filter>
        <filter
          id="filter9_d_4637_181"
          x="44.8286"
          y="5.61819"
          width="37.8969"
          height="34.6693"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="7.45" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values={getColorMatrix(0.5)} />
          <feBlend
            mode="plus-lighter"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4637_181"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4637_181"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_4637_181">
          <path
            d="M0 0H1225V65C1225 70.5229 1220.52 75 1215 75H10C4.47716 75 0 70.5229 0 65V0Z"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip1_4637_181">
          <path
            d="M0 0H1225V65C1225 70.5229 1220.52 75 1215 75H10C4.47716 75 0 70.5229 0 65V0Z"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip2_4637_181">
          <rect
            width="269.884"
            height="273.9"
            fill="white"
            transform="translate(-102.496 144.049) rotate(-66.5294)"
          />
        </clipPath>
        <clipPath id="clip3_4637_181">
          <rect
            width="336"
            height="341"
            fill="white"
            transform="translate(878 -111)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
